/*
* Copyright (C) Regione Lombardia
*/
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { doDownload } from '@core/utilities';
import { environment } from '@env/environment';
import {
    DocumentoManutenzione,
    Manutenzione
} from '@models';
import { Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ManutenzioneService {

    constructor(
        private httpClient: HttpClient
    ) { }



    /* Manutenzione: CRUD */
    public create(params: Manutenzione): Observable<Manutenzione> {
        return this.httpClient.post<Manutenzione>(`${environment.urlApi}/private/manutenzione`, params);
    }
    public read(idManutenzione: number): Observable<Manutenzione> {
        return this.httpClient.get<Manutenzione>(`${environment.urlApi}/private/manutenzione/${idManutenzione}`);
    }
    public update(params: Manutenzione): Observable<Manutenzione> {
        return this.httpClient.put<Manutenzione>(`${environment.urlApi}/private/manutenzione`, params);
    }
    public delete(idManutenzione: number) {
        return this.httpClient.delete(`${environment.urlApi}/private/manutenzione/${idManutenzione}`, { observe: 'response' });
    }

    /* Informazioni aggiuntive */
    public documentoManutenzioneByIdManutenzione(idManutenzione: number): Observable<DocumentoManutenzione[]> {
        return this.httpClient.get<DocumentoManutenzione[]>(`${environment.urlApi}/private/manutenzione/${idManutenzione}/documento-manutenzione`);
    }

    /* Documento manutenzione: CRUD */
    public insertDocumento(file: any, idManutenzione: number, documento: DocumentoManutenzione): Observable<any> {
        const fileData = new FormData();
        fileData.append('file', file);
        fileData.append('didascalia', documento.didascalia);
        fileData.append('idClasseDocumento', documento.idClasseDocumento.toString());
        fileData.append('docPublic', documento.docPublic.toString());
        return this.httpClient.post<DocumentoManutenzione>(`${environment.urlApi}/private/documento-manutenzione/upload/${idManutenzione}`, fileData);
    }
    
    public updateDocumentoManutenzione(documento: DocumentoManutenzione): Observable<any> {
        const params = {
            idDocumento: documento.idDocumento,
            idClasseDocumento: documento.idClasseDocumento,
            didascalia: documento.didascalia,
            docPublic : documento.docPublic

        }
        return this.httpClient.put<DocumentoManutenzione>(`${environment.urlApi}/private/documento-manutenzione`, params);
    }

    public deleteDocumento(idDocumentoManutenzione: number): Observable<any> {
        return this.httpClient.delete<DocumentoManutenzione>(`${environment.urlApi}/private/documento-manutenzione/${idDocumentoManutenzione}`);
    }
    public downloadDocumento(item: DocumentoManutenzione) {
        return this.httpClient.get(`${environment.urlApi}/private/documento-manutenzione/download/${item.idDocumento}`, {
            responseType: 'blob'
        }).pipe(
            tap((response) =>
                doDownload(
                    response,
                    item.nomeDocumento.substring(0, item.nomeDocumento.indexOf('.')),
                    item.nomeDocumento.substring(item.nomeDocumento.indexOf('.') + 1)
                )
            )
        );
    }


}
